// src/pages/ProjectDetails/SMA/SMA.jsx
import React, { useMemo, useState } from "react";
import XIcon from '@mui/icons-material/X';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import ButtonComponent from "../../../components/uikit/components/Button/ButtonComponent";
import Addicon from "../../../assets/images/FaPlus.svg";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import "./socialAnalysis.css";

const Section = ({ title, icon: Icon, values, setValues, placeholder }) => {
  const addField = () => {
    if (values.length < 3) setValues([...values, ""]);
  };

  const updateValue = (idx, val) => {
    const copy = [...values];
    copy[idx] = val;
    setValues(copy);
  };

  const removeField = (idx) => {
    const copy = [...values];
    copy.splice(idx, 1);
    setValues(copy);
  };

  return (
    <div className="sma-card">
      <div className="sma-header">
        <div className="sma-header-left">
          <span className="sma-icon" aria-hidden="true"><Icon /></span>
          <h3 className="sma-title">{title}</h3>
        </div>

        <div className="long" style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <img src={Addicon} alt="add" className="add-file-icon" />
          <ButtonComponent
            onClick={addField}
            variant="contained"
            btnType="primary"
            text="Add"
            className="btnPrimaryOutline small-btn"
            disabled={values.length >= 3}
            title={values.length >= 3 ? "Maximum 3 inputs reached" : `Add ${title} input`}
          />
        </div>
      </div>

      <div className="sma-inputs">
        {values.map((val, idx) => (
          <div className="sma-input-row" key={`${title}-${idx}`}>
            <input
              type="text"
              value={val}
              onChange={(e) => updateValue(idx, e.target.value)}
              placeholder={placeholder}
              className="sma-input"
            />
            <button
              type="button"
              className="sma-remove-btn"
              onClick={() => removeField(idx)}
              aria-label={`Remove ${title} input ${idx + 1}`}
              title="Remove"
            >
              <DeleteForeverIcon sx={{ color: '#FF0000' }} />
            </button>
          </div>
        ))}

        {values.length === 0 && (
          <div className="sma-empty-hint">No inputs yet. Click “Add” to create one.</div>
        )}
      </div>

      <div className="sma-footer">
        <span className="sma-limit-hint">Max 3 inputs</span>
      </div>
    </div>
  );
};

const SocialAnalysis = () => {
  const [twitterInputs, setTwitterInputs] = useState([""]);
  const [linkedinInputs, setLinkedinInputs] = useState([""]);
  const [youtubeInputs, setYoutubeInputs] = useState([""]);

  // Disable Save until at least one non-empty value exists in any section
  const isSaveDisabled = useMemo(() => {
    const hasAny =
      twitterInputs.some(v => v.trim().length > 0) ||
      linkedinInputs.some(v => v.trim().length > 0) ||
      youtubeInputs.some(v => v.trim().length > 0);
    return !hasAny;
  }, [twitterInputs, linkedinInputs, youtubeInputs]);

  return (
    <div className="container-fluid pt-3">
      <div className="card MVOC-card w-100 border-none">
        <span className="project-title-text">Social Media Analysis</span>

        <div className="sma-grid">
          <Section
            title=""
            icon={XIcon}
            values={twitterInputs}
            setValues={setTwitterInputs}
            placeholder="Enter X keyword or URL"
          />

          <Section
            title="LinkedIn"
            icon={LinkedInIcon}
            values={linkedinInputs}
            setValues={setLinkedinInputs}
            placeholder="Enter LinkedIn keyword or URL"
          />

          <Section
            title="YouTube"
            icon={YouTubeIcon}
            values={youtubeInputs}
            setValues={setYoutubeInputs}
            placeholder="Enter YouTube keyword or URL"
          />
        </div>
      </div>

      <div className="d-flex w-100 my-3 justify-content-end">
        <ButtonComponent
          variant="contained"
          btnType="primary"
          text="Save & Proceed"
          className="btnPrimary"
          disabled={isSaveDisabled}
          title={isSaveDisabled ? "Please enter at least one URL or keyword" : "Save & Proceed"}
        />
      </div>
    </div>
  );
};

export default SocialAnalysis;